import { Divider, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import ProductPriceTypography from 'artkive/components/PageSections/ProductPriceTypography'
import DigitalStorage from 'artkive/components/sections/DigitalStorage'
import Testimonial from 'artkive/components/sections/Testimonial'
import { TrackButton } from 'artkive/components/Tracker'
import theme from 'artkive/utils/theme'

export const gutters = ({ breakpoints }) => ({
  [breakpoints.up('md')]: {
    paddingLeft: 40,
    paddingRight: 40,
  },
})

export const sectionStyles = (muiTheme) => ({
  root: {},
  container: gutters(muiTheme),
  titleWrap: {},
})

export const faqStyles = (muiTheme) => ({
  container: gutters(muiTheme),
  question: {
    [muiTheme.breakpoints.down('sm')]: {
      fontSize: 18,
      lineHeight: 1.4,
    },
  },
  item: {
    [muiTheme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
})

export const HeroTitle = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    maxWidth: 520,
  },
}))

// The frames set the hero price at 36px (ProductPriceTypography's default is 32px) in a 44px row. "normal" line
// height depends on the Montserrat file's metrics, so it's pinned.
export const HeroPrice = styled(ProductPriceTypography)({
  fontSize: '2.25rem',
  lineHeight: '44px',
})

export const HeroDividerWrapper = styled('div')({
  marginBottom: 24,
})

export const HeroDivider = styled(Divider)({
  backgroundColor: theme.colors.grey[300],
})

export const CtaButton = styled(TrackButton)({
  minWidth: 220,
  padding: '12px 24px',
})

export const KeepsakeTestimonial = withStyles({
  userInfo: {
    marginTop: 20,
  },
  userName: {
    marginLeft: 0,
  },
  name: {
    fontSize: '1rem',
    lineHeight: 1.6,
  },
})(Testimonial)

export const KeepsakeDigitalStorage = withStyles(({ breakpoints }) => ({
  bullet: {
    [breakpoints.up('md')]: {
      maxWidth: 420,
    },
  },
}))(DigitalStorage)
